<template>
  <div>
    <el-tooltip :content="$t('T_SET_SAVE')" placement="left" effect="light">
      <!-- <div @click="setSave()" class="vertical-button set-history-btn"><span>{{ $t('T_SET_SAVE') }}</span></div> -->
      <img @click="setSave()" class="saveHistoryIcon" src='../../assets/parts/icon/save.png'/>
    </el-tooltip>
    <el-popover ref="popover" placement="right" :width="1200" trigger="click" >
      <template #reference>
        <el-tooltip :content="$t('T_SET_HISTORY')" placement="left" effect="light">
          <!-- <div @click="getHistory()" class="vertical-button set-history-btn"> <span>{{ $t('T_SET_HISTORY') }}</span></div> -->
          <img @click="getHistory()" class="saveHistoryIcon" src='../../assets/parts/icon/open.png'/>
        </el-tooltip>
      </template>
      <div class="historyTable">
        <el-table :data="gridData" @row-click="handleRowClick"   :row-class-name="tableRowClassName" :highlight-current-row = true
        class="rowStyle " :header-cell-style="{ background: 'rgb(68,114,196)' }" style="width: 100%"
        height="300">
          <el-table-column fixed="left" width="1" prop='radio' v-show="false" >
            <template slot-scope="scope">
              <el-radio v-show="false" v-model='radioSelected' :label='scope.$index'>&nbsp;</el-radio>
            </template>
          </el-table-column>
          <!-- モード -->
          <el-table-column width="130" prop="tabActiveName" >
            <template slot="header">
              <el-tooltip :content="$t('T_MODE_SIMPLE_UI')" placement="bottom" effect="light">
                <div class="col-title">
                  {{$t('T_MODE_SIMPLE_UI')}}
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span>{{getMode(scope.row.tabActiveName)}}</span>
              <br/>
              <span>{{getSubMode(scope.row.searchTabActive)}}</span>
            </template>
          </el-table-column>
          <!-- 製品 -->
          <el-table-column width="120" prop="selectedModelData.name" :label="$t('T_PRODUCT')" >
            <template slot="header">
              <el-tooltip :content="$t('T_PRODUCT')" placement="bottom" effect="light">
                <div class="col-title">
                {{$t('T_PRODUCT')}}
              </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{getModelLabel(scope.row.selectedModelData.name)}}
            </template>
          </el-table-column>
          <!-- 投写レンズ -->
          <el-table-column width="90" prop="selectedLensData.name" :label="$t('T_PRO_LENS')" >
            <template slot="header">
              <el-tooltip :content="$t('T_PRO_LENS')" placement="bottom" effect="light">
                <div class="col-title">
                {{$t('T_PRO_LENS')}}
              </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{getLensName(scope.row.selectedLensData.name)}}
            </template>
          </el-table-column>
          <!-- 部屋サイズ -->
          <el-table-column width="130" prop="houseInfo" :label="$t('T_ROOM_SIZE2')" >
            <template slot="header">
              <el-tooltip :content="$t('T_ROOM_SIZE2')" placement="bottom" effect="light">
                <div class="col-title">
                  {{$t('T_ROOM_SIZE2')}}
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{getHouseInfo(scope.row.houseInfo, scope.row.tabActiveName, scope.row.searchTabActive)}}
            </template>
          </el-table-column>
          <!-- 設置姿勢 -->
          <el-table-column width="90" prop="houseInfo" :label="$t('T_POSITION')" >
            <template slot="header">
              <el-tooltip :content="$t('T_POSITION')" placement="bottom" effect="light">
                <div class="col-title">
                {{$t('T_POSITION')}}
              </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{getProPosition(scope.row.tabActiveName,scope.row.searchTabActive, scope.row.position, scope.row.blendingParam.position )}}
            </template>
          </el-table-column>
          <!-- スクリーンサイズ -->
          <el-table-column width="80" prop="screenSize" :label="$t('T_SCREEN_SIZE')" >
            <template slot="header">
              <el-tooltip :content="$t('T_SCREEN_SIZE')" placement="bottom" effect="light">
                <div class="col-title">
                {{$t('T_SCREEN_SIZE')}}
              </div>
              </el-tooltip>

            </template>
            <template slot-scope="scope">
              {{parseFloat(scope.row.screenSize).toFixed(2)}}
            </template>
          </el-table-column>
          <!-- アスペクト比 -->
          <el-table-column width="100" prop="aspectRatio" :label="$t('T_ASPECT_RATIO')" >
            <template slot="header">
              <el-tooltip :content="$t('T_ASPECT_RATIO')" placement="bottom" effect="light">
                <div class="col-title">
                {{$t('T_ASPECT_RATIO')}}
              </div>
              </el-tooltip>

            </template>
            <template slot-scope="scope">
              {{getRatio(scope.row.curveShape,scope.row.tabActiveName,scope.row.searchTabActive,scope.row.blendingParam.ratio,scope.row.aspectRatio)}}
            </template>
          </el-table-column>
          <!-- スクリーン形状 -->
          <el-table-column width="100" prop="curveShape" :label="$t('T_CURVE_SCREEN_SHAPE')" >
            <template slot="header">
              <el-tooltip :content="$t('T_CURVE_SCREEN_SHAPE')" placement="bottom" effect="light">
                <div class="col-title">
                {{$t('T_CURVE_SCREEN_SHAPE')}}
              </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{getCurveShape(scope.row.curveShape,scope.row.tabActiveName,scope.row.searchTabActive,scope.row.blendingParam.shapeShow)}}
            </template>
          </el-table-column>
          <!-- 台数 -->
          <el-table-column width="50" prop="curveShape" :label="$t('T_PRO_NUM')" >
            <template slot="header">
              <el-tooltip :content="$t('T_PRO_NUM')" placement="bottom" effect="light">
                <div class="col-title">
                {{$t('T_PRO_NUM')}}
              </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              {{getProNum(scope.row.simulateTabData, scope.row.simulateTabSele, scope.row.tabActiveName, scope.row.searchTabActive, scope.row.blendingParam.shapeShow)}}
            </template>
          </el-table-column>
          <!-- 出力 -->
          <el-table-column min-width="30" prop="curveShape" :label="$t('T_SIMPLEUI_OUTPUT')" >
            <template slot="header">
              <el-tooltip :content="$t('T_SIMPLEUI_OUTPUT')" placement="bottom" effect="light">
                <div class="col-title">
                {{$t('T_SIMPLEUI_OUTPUT')}}
              </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <i  @click.stop="exportInfo(scope.row)" class="el-icon-document hoverPointer"></i>
            </template>
          </el-table-column>
          <!-- 保存日時 -->
          <el-table-column  prop="saveDate" :label="$t('T_SAVE_DATE')" >
            <template slot="header">
              <el-tooltip :content="$t('T_SAVE_DATE')" placement="bottom" effect="light">
                <div class="col-title">
                  {{$t('T_SAVE_DATE')}}
                </div>
              </el-tooltip>

            </template>
          </el-table-column>
          <!-- 削除 -->
          <el-table-column min-width="30" :label="$t('T_DEL_SET')" >
            <template slot="header">
              <el-tooltip :content="$t('T_DEL_SET')" placement="bottom" effect="light">
                <div class="col-title">
                {{$t('T_DEL_SET')}}
              </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <i  @click.stop="deleteRow(scope.row)" class="el-icon-close hoverPointer"></i>
            </template>
          </el-table-column>
          <div slot="empty">
            <span>{{ $t('T_NO_DATA') }}</span>
          </div>
        </el-table>
      </div>
      <el-upload
          accept="json"
          action
          :on-change="fileChange"
          :auto-upload="false"
          :show-file-list="false"
        >
        <div class="load-simulation-btn">{{ $t('T_LOAD_SIMULATION_RESULT') }}</div>
       </el-upload>
    </el-popover>
    <el-dialog :title="$t('T_CONTENT')" :visible.sync="saveHistoryStatus" width="480px" :close-on-click-modal="false" class="out_of_spec_dialog" >
      <div>
        <p>{{$t('T_SET_SAVE_SUCCESS')}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveHistoryStatus = false" size="medium">{{$t('T_OK')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('T_CONTENT')" :visible.sync="beyondSaveNumStatus" width="480px" :close-on-click-modal="false" class="out_of_spec_dialog" >
      <div>
        <p>{{$t('T_DEL_MSG')}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="beyondSaveNumStatus = false" size="medium">{{$t('T_OK')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'
import { saveAs } from 'file-saver'
export default {
  data () {
    return {
      saveHistoryStatus: false,
      beyondSaveNumStatus: false,
      gridData: [],
      initialState: {
        houseInfo: {
          // room size
          roomW: 1000,
          roomH: 500,
          roomD: 2000
        },
        graph: {
          // projector coordinates
          pjX: 250,
          pjY: 311,
          pjZ: 175,
          // screen size
          scrnW: 215,
          scrnH: 135.3,
          // board size
          boardW: 220,
          boardH: 140.3,

          f_s2d: null,
          f_d2s: null,
          vLensShift: {max: 0, min: 0},
          hLensShift: {max: 0, min: 0},
          vhLensShift: null,
          // 单位
          unit: 'T_METRE_M'
        },
        vLensShiftNow: 0,
        hLensShiftNow: 0,
        temVLensShift: {max: 0, min: 0},

        // 3d转化过之后的数据点
        drawData: null,
        blackDrawData: null,
        rangeDrawData: null,
        centerPointData: null,
        dashData: null,
        dashDataRemain: null,
        // 记录屏幕四个点的坐标（黑边的点）（只与主墙相交，不与上下左右墙相交）
        screen4Point: null,

        aspectRatio: null,

        userInputModelName: null,
        specificationMatchingModelData: null,
        installMatchingModelData: null,
        searchMatchingModelData: null,
        searchSelectedModelData: null,
        searchMatchingLensID: null,
        searchSelectedLensData: null,

        bmMatchingModelData: null,
        bmSelectedModelData: null,
        bmMatchingLensID: null,
        bmSelectedLensData: null,

        htmMatchingModelData: null,
        htmSelectedModelData: null,
        htmMatchingLensID: null,
        htmSelectedLensData: null,

        matchingModelData: null,
        selectedModelData: null,
        matchingLensID: null,
        selectedLensData: null,
        cateValue: 0,
        selectRatioData: null,

        cateRadio: 'bmRadio', // Bm:'bmRadio' Htm:'htmRadio'
        // 投影仪尺寸
        lenghProInit: 78.8,
        widthProInit: 50,

        // 屏幕大小
        screenSize: 100,
        // 1.576
        // 页面比例
        proportion: 0,
        brightness: 140,
        vAngleFlag: false,
        vAngle: 0,
        hAngleFlag: false,
        hAngle: 0,
        offset: 0,
        floor2bottom: 257.8,

        // 英寸转化
        inchCom: 2.54,
        // 黑边处理时的长宽
        initScreenSize: {
          w: 215,
          h: 135.3
        },
        pjImgType: 0,

        // Not used
        dist: 0,
        pjHeight: 0,
        f_vOffset: null,
        frontSlider: 0,
        oldT: {
          x: 0,
          y: 0
        },
        gain: '1.0',
        application: '0',
        // 主视图Change the projector position字段
        projectorChecked: true,
        screenMoveChecked: false,
        //  threeD Change the projector position字段
        threeDPJChecked: true,
        // condition页面Throw distance的checkbox字段
        throwDistanceChecked: false,
        // condition页面Screen Size的checkbox字段
        screenSizeChecked: false,
        // condition页面Screen Size的checkbox字段
        realThrowDistanceChecked: false,
        floorFootProjectorChecked: false,
        // condition页面ustWall、screenSizeChecked===true，throwDistanceChecked===true时T端值
        ustThrowDisSlidertMax: 0,
        ustScreenSizeMax: 0,
        // condition页面Screen Size的checkbox字段选中时，表示的屏幕的坐标
        pjXTip: 250,
        pjZTip: 175,
        blackSize: 0,
        centerPositionInit: null,
        projectorCheckedSide: true,
        projectorCheckedTop: true,
        // 表示点击Screen Position checkbox时，获取的屏幕左下角距下边的距离
        flToB: 0,
        flToL: 0,
        // 是否显示虚框
        dashFlag: false,
        // 判断屏幕是否接触frontView中的可移动区域
        isTouch: false,

        // 判断鼠标在哪个试图中，以触发键盘上下左右事件
        focusView: '',
        // isInFrontView: false,
        // isInSideView: false,
        // isInTopView: false,

        limitData: 0.00001,
        theme: true,
        position: 0,
        browserType: '', // IE: 'ie; Edge: 'edge'; 其他:'other'
        isUSTWall: false,
        USTPjTop: 0, // 以front view为基准,
        SimplePjTop: 0,
        USTVDragFlag: false,
        USTLenshiftV: 0,
        FTUT2screenT: 9, // FTU上端到屏幕距离
        FTUT2screenTW: 10, // 白板外、FTU上端到屏幕距离
        FTUT2screenTN: 6, // 没有白板、FTU上端到屏幕距离
        FTUB2screenT: 5, // FTU下端到屏幕距离
        FTUHeight: 4, // FTU高度
        board2screenH: 2, // 白板下端到屏幕下端的最小距离
        board2screenW: 10, // 白板左/右端到屏幕左/右端的最小距离
        boardStatusTop: 0, // 白板top值
        touchInstall: true, // 是否能安装在白板外FTU
        fingerTouchStatus: false, // true:'on', false: 'off'
        FTULocationState: false, // true:'on', false: 'off'
        whiteboardStatus: false, // true:'on', false: 'off'
        showInputFlag: true,
        textDataView: '',
        keyStoneVertical: 0,
        keyStoneHorizontal: 0,
        outOfSpecVal: false,
        isOutOfSpec: false,
        isVAngleOut: false,
        languageDefault: 'en',
        searchTabActive: 'Search', // 'Search', 'Categolies', 'Specification', 'InstallCondition', 'Blending','CurvedSurface'
        ustLensToFrontPj: 0, // lx
        curveShape: '1', // '0':垂直, '1':水平
        curveDirection: '0', // '0':凹面, '1':凸面
        curveDepth: 0,
        isSimple: false,
        lensShiftRangeBool: false,
        lensShiftRange: false,
        brightnessGuide: false,
        curveCenter: null,
        DisableNone: false,
        curveRadius: 0,
        curveCentralAngle: 0,
        // 多台时投影仪的点坐标
        muPoints: null,
        SettingActive: ['1'],
        screenActive: ['1'],
        throwDisActive: ['1'],
        setfontSize: false,
        tabActiveName: 'Advanced', // 'Basic' 'Advanced'
        indAngleSwitch: false,
        indAngleRemainPints: null,
        cornerCorAreas: null,
        isOnCornerAreas: false,
        touchWallFlag: false,
        blendingAvaPoint: [],
        isProjectPosition: true,
        // 多台时表格数据
        simulateTabData: [],
        // 多台时表格中默认选项
        simulateTabSele: 0,
        blendingUnit: 'T_METRE_M',
        projectorSize: {
          w: 32,
          h: 16
        },
        blendingParam: {
          seLensData: null,
          vLensShift: null,
          hLensShift: null,
          vhLensShift: null,
          vLensShiftNow: 0,
          screenShape: '2', // '0':凹面, '1':凸面, '2': 平面,
          shapeShow: '2',
          radius: 1000,
          curveSelect: '0', // '0':中心角, '1':弧长, '2': 深度,
          angle: Math.PI / 1.5, // 中心角
          depth: '0', // 弧长
          arc: '0', // 深度
          screenHeight: 300,
          lensHeight: 150,
          lensShiftV: 0,
          lensHeightRate: {
            min: 0,
            max: 0
          },
          screenSize: {
            width: 670,
            height: 270
          },
          ratio: '16:10',
          position: '0',
          range: {
            min: 15,
            max: 45
          },
          number: {
            h: 4,
            v: 2
          }
        },
        blendingPositionLimit: {
          w: 0,
          h: 0
        },
        simulateSwitchFlag: 0, // 0表示平面多台，1表示曲面多台
        blendingEdgePoints: [],
        throwDisSlidertFormat: 0,
        throwDisSliderwFormat: 0,
        ratioScreenSizeMin: 0,
        ratioScreenSizeMax: 0,
        throwError: false,
        modeData: '0',
        fromBlending: false,
        throwDistance2screenSizWidth: 0, // install condition Throw distance 与 Screen Size Width的比值
        languageFlag: false, // 紧急对应maintenance修改后，top画面切换其它国家语言=>index页面还是maintenance语言
        mixRateHVal: '',
        mixRateVVal: '',
        contrastData: 0, // 実コントラスト
        distance2Wall: 0, // 镜头到墙面的当前距离(拖拽),
        curvedCorrectionScreen: {
          w: 0,
          h: 0,
          size: 0
        }, // 边缘融合凹面(凸面)箭头拖拽,屏幕大小的尺寸
        saveDate: '',
        key: 0,
        throwDisSliderMin: 0,
        throwDisSliderMax: 0,
        throwDisSliderw: 0,
        throwDisSlidert: 0,
        overlapH: 0,
        overlapV: 0
      }
    }
  },
  computed: {
    ...mapState(['searchTabActive', 'selectedModelData', 'selectedLensData', 'matchingLensID', 'aspectRatio', 'cateRadio',
      'graph', 'vLensShiftNow', 'hLensShiftNow', 'vAngle', 'hAngle', 'position', 'browserType', 'throwDistance2screenSizWidth', 'blendingParam', 'screenSizeChecked', 'isSimple', 'radioSelected', 'selectedKey'])

  },
  watch: {

  },
  mounted () {
  },
  methods: {
    ...mapMutations([
      'SET_ALL',
      'SET_SAVE_DATE',
      'SET_RESET_STATE',
      'SET_HISTORY_RADIO',
      'SET_HISTORY_KEY',
      'SET_ISHISTORYROWCLICK',
      'SET_POSITION',
      'SET_SCREENSIZECHECKED'
    ]),
    setSave () {
      this.$commonIndexedDBJs.dataGet('store', (data) => {
        if (data.length >= 5) {
          this.beyondSaveNumStatus = true
        } else {
          this.SET_SAVE_DATE(moment().format('YYYY/MM/DD HH:mm'))
          var datas = Object.assign({}, this.$store.state)
          delete datas.versionInfo
          // delete datas.specificationMatchingModelData
          // delete datas.installMatchingModelData
          // delete datas.searchMatchingModelData
          // delete datas.matchingModelData
          // delete datas.view
          // delete datas.unitDataOptions
          // delete datas.languageOptions
          // delete datas.resolutionOptions
          this.$commonIndexedDBJs.dataPut('store', datas)
          this.saveHistoryStatus = true
        }
      })
    },
    getHistory (type, row) {
      this.$commonIndexedDBJs.dataGet('store', (data) => {
        this.gridData = data
        if (type === 'delete') {
          let index = this.gridData.findIndex(
            item => item.key === row.key
          )
          if (this.radioSelected === index) {
            this.SET_HISTORY_RADIO('')
            this.SET_HISTORY_KEY('')
          } else {
            let index2 = this.gridData.findIndex(
              item => item.key === this.selectedKey
            )
            if (index2 > -1) {
              this.SET_HISTORY_RADIO(index2)
              // this.SET_KEY(row.key)
            }
          }
        }
      })
    },
    handleRowClick (row, event, column) {
      try {
        this.SET_ISHISTORYROWCLICK(true)
        console.log('this.$store.state', this.$store.state)
        this.SET_POSITION(row.position)
        this.SET_SCREENSIZECHECKED(row.screenSizeChecked)
        let index = this.gridData.findIndex(
          item => item.key === row.key
        )
        if (row.tabActiveName === 'Advanced' && row.searchTabActive === 'Blending') {
          this.SET_RESET_STATE(this.initialState)
        }
        this.SET_ALL(row)
        if (index > -1) {
          this.SET_HISTORY_RADIO(index)
          this.SET_HISTORY_KEY(row.key)
        }
        setTimeout(() => {
          if (row.aspectRatio !== this.$store.state.aspectRatio || row.screenSize !== Math.round(this.$store.state.screenSize)) {
            this.SET_ALL(row)
            if (index > -1) {
              this.SET_HISTORY_RADIO(index)
              this.SET_HISTORY_KEY(row.key)
            }
          }
        }, 500)
        setTimeout(() => {
          if (row.aspectRatio !== this.$store.state.aspectRatio || row.screenSize !== Math.round(this.$store.state.screenSize)) {
            this.SET_ALL(row)
            if (index > -1) {
              this.SET_HISTORY_RADIO(index)
              this.SET_HISTORY_KEY(row.key)
            }
          }
          this.SET_ISHISTORYROWCLICK(false)
        }, 500)
        this.$i18n.locale = row.languageDefault
        this.$refs.popover.doClose()
      } catch (e) {
        alert(this.$t('T_ALERT_DISPLAY_INPUT_ERROR'))
      }
    },
    tableRowClassName ({row, rowIndex}) {
      if (rowIndex === this.radioSelected) {
        return 'current-row'
      }
      return ''
    },
    getMode (tabActiveName, searchTabActive) {
      if (tabActiveName === 'Basic') {
        return this.$t('T_SIMPLE_MODE')
      } else {
        return this.$t('T_ADVANCED_MODE')
      }
    },
    getSubMode (searchTabActive) {
      if (searchTabActive === 'Search') {
        return this.$t('T_SEARCH_MODEL')
      } else if (searchTabActive === 'Categolies') {
        return this.$t('T_SEARCH_CATEGORY')
      } else if (searchTabActive === 'Specification') {
        return this.$t('T_SEARCH_SPEC')
      } else if (searchTabActive === 'InstallCondition') {
        return this.$t('T_SEARCH_CONDITION')
      } else if (searchTabActive === 'CurvedSurface') {
        return this.$t('T_CURVE_SURFACE')
      } else if (searchTabActive === 'Blending') {
        return this.$t('T_EDGE_BLENDING')
      }
    },
    getLensName (lensName) {
      if (lensName) {
        return lensName.split('(')[0]
      } else {
        return '-'
      }
    },
    getHouseInfo (houseInfo, mode, subMode) {
      if (mode === 'Advanced' && subMode === 'Blending') {
        return '-'
      } else {
        return 'D' + houseInfo.roomD / 100 + this.$t('T_METRE') + ' x ' + 'W' + houseInfo.roomW / 100 + this.$t('T_METRE') + ' x ' + 'H' + houseInfo.roomH / 100 + this.$t('T_METRE')
      }
    },
    getProPosition (mode, subMode, proPosition, blendingProPosition) {
      if (mode === 'Advanced' && subMode === 'Blending') {
        if (blendingProPosition === '0') {
          return this.$t('T_POS_DESKTOP')
        } else if (blendingProPosition === '1') {
          return this.$t('T_POS_CEILING')
        } else {
          return '-'
        }
      } else {
        if (proPosition === 0) {
          return this.$t('T_POS_DESKTOP')
        } else if (proPosition === 1) {
          return this.$t('T_POS_CEILING')
        } else if (proPosition === 2) {
          return this.$t('T_POS_WALL')
        } else {
          return '-'
        }
      }
    },
    getRatio (curveShape, mode, subMode, blendingratio, aspectRatio) {
      if (mode === 'Advanced' && subMode === 'Blending') {
        return blendingratio
      } else {
        return aspectRatio
      }
    },
    getCurveShape (curveShape, mode, subMode, blendingShape) {
      if (mode === 'Advanced' && subMode === 'CurvedSurface') {
        if (curveShape === '0') {
          return this.$t('T_CURVE_VERTICAL_CURVE')
        } else if (curveShape === '1') {
          return this.$t('T_CURVE_HORIZONTAL_CURVE')
        } else {
          return '-'
        }
      } else if (mode === 'Advanced' && subMode === 'Blending') {
        if (blendingShape === '0') {
          return this.$t('T_CURVE_CONCAVE')
        } else if (blendingShape === '1') {
          return this.$t('T_CURVE_CONVEX')
        } else if (blendingShape === '2') {
          return this.$t('T_FLAT')
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    getProNum (simulateTabData, simulateTabSele, mode, subMode, blendingShape) {
      try {
        if (mode === 'Advanced' && subMode === 'Blending') {
          if (blendingShape === '2') {
            return simulateTabData[simulateTabSele].h + '*' + simulateTabData[simulateTabSele].v
          } else {
            return simulateTabData[simulateTabSele].total
          }
        } else {
          return '-'
        }
      } catch (e) {
        return '-'
      }
    },
    deleteRow (row) {
      this.$commonIndexedDBJs.dataDelete('store', row.key, (data) => {
        this.getHistory('delete', row)
      })
    },

    exportInfo (datas) {
      // delete datas.versionInfo
      // delete datas.specificationMatchingModelData
      // delete datas.installMatchingModelData
      // delete datas.searchMatchingModelData
      // delete datas.searchSelectedModelData
      // delete datas.searchMatchingLensID
      // delete datas.searchSelectedLensData
      // delete datas.bmMatchingModelData
      // delete datas.bmSelectedModelData
      // delete datas.bmMatchingLensID
      // delete datas.bmSelectedLensData
      // delete datas.htmMatchingModelData
      // delete datas.htmSelectedModelData
      // delete datas.htmMatchingLensID
      // delete datas.htmSelectedLensData
      // delete datas.matchingModelData
      // delete datas.view
      // delete datas.unitDataOptions
      // delete datas.languageOptions
      // delete datas.resolutionOptions
      delete datas.key
      // delete datas.saveDate
      let fileData = datas

      let data = JSON.stringify(fileData)
      var blob = new Blob([data], { type: '' })
      saveAs(blob, 'simulationResult.json')
    },
    fileChange (file) {
      this.modelData = null
      let reader = new FileReader()
      reader.readAsText(file.raw)
      reader.onload = e => {
        // if (this.isValidJSON(e.target.result)) {
        //   this.modelData = JSON.parse(e.target.result)
        //   console.log('this.modelData', this.modelData)
        //   this.$commonIndexedDBJs.dataGet('store', (data) => {
        //     if (data.length >= 5) {
        //       this.beyondSaveNumStatus = true
        //     } else {
        //       this.SET_SAVE_DATE(moment().format('YYYY/MM/DD HH:mm'))
        //       this.modelData.saveDate = moment().format('YYYY/MM/DD HH:mm')
        //       this.$commonIndexedDBJs.dataPut('store', this.modelData)
        //       this.$refs.popover.doClose()
        //       // this.saveHistoryStatus = true
        //     }
        //   })
        // } else {
        //   alert(this.$t('T_ALERT_DISPLAY_INPUT_ERROR'))
        // }
        if (this.isValidJSON(e.target.result)) {
          this.SET_HISTORY_RADIO('')
          this.handleRowClick(JSON.parse(e.target.result))
        } else {
          alert(this.$t('T_ALERT_DISPLAY_INPUT_ERROR'))
        }
      }
    },
    isValidJSON (text) {
      try {
        JSON.parse(text)
        return true
      } catch (error) {
        return false
      }
    },
    getModelLabel (label) {
      return this.$commonJs.getModelLabelByName(label)
    }
  }
}
</script>
<style >
.vertical-button {
  writing-mode: vertical-lr; /* 从左向右，从上向下 */
  transform: rotate(360deg); /* 修正按钮文字方向 */
  width: 30px; /* 设置宽度以适应文字高度 */
  white-space: nowrap; /* 防止文字换行 */
  overflow: hidden; /* 隐藏超出部分 */
  letter-spacing:1.5px
}
.set-history-btn{
  font-size: 12px;
  background: rgb(0, 50, 152);
  color: rgb(255, 255, 255);
  cursor: pointer;
  padding: 15px 0px;
  padding-left: 6px;
  height: 100px;
  margin-top: 3px;
  text-overflow:ellipsis
}
.highlight-row {
  background-color: red !important;
}
.hoverPointer{
  cursor: pointer;
  font-size: 20px;
}
.rowStyle{
  font-size: 12px !important;
}
.rowStyle :hover{
  cursor: pointer;
}
.load-simulation-btn {
  font-size: 12px;
  background: rgb(0, 50, 152) !important;
  color: rgb(255, 255, 255);
  cursor: pointer;
  width: 1176px;
  text-align: center;
  padding: 13px 0px;
}
.col-title{
  padding: 5px 0px;
  font-size: 13px;
  white-space: normal;
  color: white;
  white-space: nowrap; /* 防止文字换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow:ellipsis
}
.historyTable .el-table th>.cell{
  white-space: normal;
  word-break: break-all;
  height: auto;
  min-height: 40px;
  line-height: 20px;
}
.historyTable .el-table{
 font-size: 12px;
}
</style>
<style scoped>
.saveHistoryIcon{
  width: 28px;
  cursor: pointer;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/searchTabs/userSaveHistory.vue